webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueHead = __webpack_require__(46);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _vueRouter = __webpack_require__(13);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(12);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuexRouterSync = __webpack_require__(14);
	
	var _App = __webpack_require__(52);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(6);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(18);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _middlewares = __webpack_require__(17);
	
	var _middlewares2 = _interopRequireDefault(_middlewares);
	
	var _interceptors = __webpack_require__(16);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueHead2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.interceptors.concat(_interceptors2.default);
	
	var router = new _vueRouter2.default({
	  linkActiveClass: 'active'
	});
	
	router.map(_routes2.default);
	
	(0, _middlewares2.default)(router);
	
	(0, _vuexRouterSync.sync)(_store2.default, router);
	
	router.start(_App2.default, 'app');

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAVBAR_DEFAULT = exports.NAVBAR_DEFAULT = 'NAVBAR_DEFAULT';
	var NAVBAR_INVERSE = exports.NAVBAR_INVERSE = 'NAVBAR_INVERSE';

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(15);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _navbar = __webpack_require__(21);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    navbar: _navbar2.default
	  },
	  strict: debug
	});

/***/ },
/* 7 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(31)
	  , IE8_DOM_DEFINE = __webpack_require__(36)
	  , toPrimitive    = __webpack_require__(38)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(1) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(49)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = [{
	  request: function request(_request) {
	    return _request;
	  },
	
	  response: function response(_response) {
	    if ([400, 401].find(function (x) {
	      return _response.status === x;
	    })) {}
	
	    if (_response.status === 500) {}
	
	    return _response;
	  }
	}];

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (router) {
	  router.beforeEach(function (transition) {
	    if (transition.to.auth) {}
	
	    transition.next();
	  });
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(55);
	
	var _2 = _interopRequireDefault(_);
	
	var _Home = __webpack_require__(54);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _About = __webpack_require__(53);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  '/': {
	    component: _Home2.default
	  },
	  '/about': {
	    component: _About2.default
	  },
	  '*': {
	    component: _2.default
	  }
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.navbarInverse = exports.navbarDefault = undefined;
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var navbarDefault = exports.navbarDefault = function navbarDefault(_ref) {
	  var dispatch = _ref.dispatch;
	  var state = _ref.state;
	
	  dispatch(types.NAVBAR_DEFAULT);
	};
	
	var navbarInverse = exports.navbarInverse = function navbarInverse(_ref2) {
	  var dispatch = _ref2.dispatch;
	  var state = _ref2.state;
	
	  dispatch(types.NAVBAR_INVERSE);
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isNavbarInverse = exports.isNavbarInverse = function isNavbarInverse(state) {
	  return state.navbar.inverse;
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(28);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localStorage = window.localStorage;
	
	var state = {
	  inverse: false
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.NAVBAR_DEFAULT, function (state) {
	  state.inverse = false;
	
	  localStorage.setItem('navbar_inverse', state.inverse);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.NAVBAR_INVERSE, function (state) {
	  state.inverse = true;
	
	  localStorage.setItem('navbar_inverse', state.inverse);
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(6);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(11);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default
	  },
	  head: {
	    title: {
	      inner: 'About'
	    }
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Navbar = __webpack_require__(11);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default
	  },
	  ready: function ready() {
	    (0, _jquery2.default)('[data-toggle="tooltip"]').tooltip();
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(20);
	
	var _actions = __webpack_require__(19);
	
	exports.default = {
	  ready: function ready() {
	    if (window.localStorage.getItem('navbar_inverse') === 'true') {
	      this.navbarInverse();
	    }
	  },
	
	  vuex: {
	    getters: {
	      isNavbarInverse: _getters.isNavbarInverse
	    },
	    actions: {
	      navbarDefault: _actions.navbarDefault,
	      navbarInverse: _actions.navbarInverse
	    }
	  }
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  head: {
	    title: {
	      inner: '404'
	    }
	  },
	  ready: function ready() {
	    (0, _jquery2.default)('.container-404').css('height', (0, _jquery2.default)(window).height());
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(29), __esModule: true };

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(27);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	var $Object = __webpack_require__(7).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(30);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3)
	  , document = __webpack_require__(9).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(9)
	  , core      = __webpack_require__(7)
	  , ctx       = __webpack_require__(32)
	  , hide      = __webpack_require__(35)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(10)
	  , createDesc = __webpack_require__(37);
	module.exports = __webpack_require__(1) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(1) && !__webpack_require__(8)(function(){
	  return Object.defineProperty(__webpack_require__(33)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(3);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(34);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(1), 'Object', {defineProperty: __webpack_require__(10).f});

/***/ },
/* 40 */,
/* 41 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 42 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 43 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 44 */,
/* 45 */,
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	;(function () {
	
	  'use strict'
	
	  var opt = {
	    complement: document.title,
	    separator: '|'
	  }
	
	  var diff = []
	  var diffTitle = {}
	  var installed = false
	
	  var util = {
	    
	    /**
	     * This function return the element <head>
	     * @return {Object}
	     */
	    getHead: function () {
	      return document.getElementsByTagName('head')[0]
	    },
	
	    /**
	     * Undo the document title for previous state
	     * @param  {Object} state 
	     */
	    undoTitle: function (state) {
	      if (!state.before) return
	      document.title = state.before
	    },
	
	    /**
	     * Undo elements to its previous state
	     * @param  {Object} states
	     */
	    undo: function (states) {
	      if (!states.length) return
	      var headElement = this.getHead()
	      states.map(function (state) {
	        ;(state.before) ? headElement.replaceChild(state.before, state.after) : headElement.removeChild(state.after)
	      })
	    },
	
	    /**
	     * Change document title
	     * @param  {Object} val
	     */
	    title: function (objTitle) {
	      if (!objTitle) return
	      diffTitle.before = opt.complement
	      document.title = objTitle.inner + ' ' + (objTitle.separator || opt.separator) + ' ' + (objTitle.complement || opt.complement)
	    },
	
	    /**
	     * Manages meta tags
	     * @param  {Object} objMeta
	     */
	    meta: function (objMeta) {
	      if (!objMeta) return
	      var self = this
	
	      Object.keys(objMeta).map(function (prop) {
	        var meta = objMeta[prop]
	
	        Object.keys(meta).map(function (value) {
	
	          // set state of elements
	          var el = self.getHead().querySelector('meta[' + prop + '="' + value + '"]') || document.createElement('meta')
	          var clone = el.cloneNode(true)
	          var state = {}
	
	          // Assign Content
	          el.setAttribute('content', meta[value])
	
	          // If exists element
	          if (el.getAttribute(prop)) {
	            state.before = clone
	            state.after = el
	            diff.push(state)
	            return
	          }
	
	          // If not exists element
	          el.setAttribute(prop, value)
	          self.getHead().appendChild(el)
	          state.after = el
	          diff.push(state)
	        })
	
	      })
	    },
	
	    /**
	     * Manages link tags
	     * @param  {Object} objLink
	     */
	    link: function (objLink) {
	      if (!objLink) return
	      var self = this
	
	      Object.keys(objLink).map(function (rel) {
	        var el = self.getHead().querySelector('link[rel="' + rel + '"]') || document.createElement('link')
	        var props = objLink[rel]
	        var clone = el.cloneNode(true)
	        var state = {}
	
	        // Assign for each the props
	        Object.keys(props).map(function (prop) {
	          el.setAttribute(prop, props[prop])
	        })
	
	        // If exists element
	        if (el.getAttribute('rel')) {
	          state.before = clone
	          state.after = el
	          diff.push(state)
	          return
	        }
	
	        // If not exists element
	        el.setAttribute('rel', rel)
	        self.getHead().appendChild(el)
	        state.after = el
	        diff.push(state)
	      })
	    }
	  }
	
	  /**
	   * Plugin | vue-head
	   * 
	   * @param  {Function} Vue
	   * @param  {Object} options
	   */
	  function VueHead (Vue, options){
	    if (installed) return
	
	    installed = true
	
	    if (options) {
	      Vue.util.extend(opt, options)
	    }
	
	    Vue.mixin({
	      route: {
	      	activate: function() {
	          var self = this
	          var head = this.$options.head
	          if (!head) return
	          Object.keys(head).map(function (key) {
	            if (head[key]) {
	              var obj = (typeof head[key] === 'object') ? head[key] : head[key].bind(self)()
	              util[key](obj)
	            }
	          })
	        },
	        deactivate: function() {
	          var head = this.$options.head
	          if (!head) return
	          if (typeof head.undo === 'undefined' || head.undo) {
	            util.undoTitle(diffTitle)
	            util.undo(diff)
	          }
	          diff = []
	        }
	      }
	    })
	  }
	
	  VueHead.version = '1.0.5'
	
	  // auto install
	  if (typeof Vue !== 'undefined') {
	    Vue.use(VueHead)
	  }
	
	  if(true) {
	    module.exports = VueHead
	  } else if(typeof define === 'function' && define.amd) {
	    define(function () { return VueHead })
	  } else if (typeof window !== 'undefined') {
	    window.VueHead = VueHead
	  }
	
	})()


/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = " <router-view></router-view> ";

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = " <navbar></navbar> <div class=container> <h1>About</h1> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae ab dolores asperiores aliquam deleniti saepe. Ipsam, cum possimus nihil iure quidem nobis ex earum dolor, at odio dolores perspiciatis. Quasi.</p> </div> ";

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = " <nav class=\"navbar navbar-fixed-top\" v-bind:class=\"isNavbarInverse ? 'navbar-inverse' : 'navbar-default'\"> <div class=container> <div class=navbar-header> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar aria-expanded=false aria-controls=navbar> <span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> <a class=navbar-brand v-link=\"{ path: '/' }\">Vue Bootstrap</a> </div> <div id=navbar class=\"collapse navbar-collapse\"> <ul class=\"nav navbar-nav\"> <li v-link-active><a v-link=\"{ path: '/', exact: true }\">Home</a></li> <li v-link-active><a v-link=\"{ path: '/about' }\">About</a></li> <li><a v-link=\"{ path: '/404' }\">404</a></li> </ul> <ul class=\"nav navbar-nav navbar-right\"> <li><a class=\"btn btn-link\" v-on:click.prevent=navbarInverse>INVERSE</a></li> <li><a class=\"btn btn-link\" v-on:click.prevent=navbarDefault>DEFAULT</a></li> </ul> </div> </div> </nav> ";

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = " <navbar _v-0c35da22=\"\"></navbar> <div class=\"jumbotron text-center\" _v-0c35da22=\"\"> <div class=container _v-0c35da22=\"\"> <h1 _v-0c35da22=\"\">Hello World!</h1> <p _v-0c35da22=\"\">This is a Vue Js Webpack template with jQuery, Bootstrap Sass, and Font Awesome.</p> </div> </div> <div class=container _v-0c35da22=\"\"> <div class=text-center _v-0c35da22=\"\"> <button class=\"btn btn-lg btn-primary\" data-toggle=modal data-target=#myModal _v-0c35da22=\"\"> <i class=\"fa fa-folder-o\" _v-0c35da22=\"\"></i> Open Modal </button> <button type=button class=\"btn btn-lg btn-default\" data-toggle=tooltip data-placement=bottom title=\"Tooltip on bottom\" _v-0c35da22=\"\">Tooltip on bottom</button> </div> </div> <div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=myModalLabel _v-0c35da22=\"\"> <div class=modal-dialog role=document _v-0c35da22=\"\"> <div class=modal-content _v-0c35da22=\"\"> <div class=modal-header _v-0c35da22=\"\"> <button type=button class=close data-dismiss=modal aria-label=Close _v-0c35da22=\"\"><span aria-hidden=true _v-0c35da22=\"\">×</span></button> <h4 class=modal-title id=myModalLabel _v-0c35da22=\"\">Modal title</h4> </div> <div class=modal-body _v-0c35da22=\"\"> Hello Modal </div> <div class=modal-footer _v-0c35da22=\"\"> <button type=button class=\"btn btn-default\" data-dismiss=modal _v-0c35da22=\"\">Close</button> <button type=button class=\"btn btn-primary\" _v-0c35da22=\"\">Save changes</button> </div> </div> </div> </div> ";

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = " <div class=\"container container-404\" _v-9b08da12=\"\"> <div class=text-center _v-9b08da12=\"\"> <h1 _v-9b08da12=\"\">404</h1> <h3 _v-9b08da12=\"\">Page not found</h3> <p _v-9b08da12=\"\"> <a class=\"btn btn-lg btn-danger\" v-link=\"{ path: '/' }\" _v-9b08da12=\"\">Back to home</a> </p> </div> </div> ";

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(41)
	__vue_script__ = __webpack_require__(22)
	__vue_template__ = __webpack_require__(47)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(48)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(42)
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(50)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(43)
	__vue_script__ = __webpack_require__(26)
	__vue_template__ = __webpack_require__(51)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.7460f95b5df874bbfb26.js
 **/